import React, { useEffect, useState, useRef } from "react";
import {
  DialogContent,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  CircularProgress,
  useTheme,
  useMediaQuery,
  createStyles,
  makeStyles,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import _ from "lodash";
import ButtonCommon from "../../../../../components/buttons/ButtonCommon";
import CategoryMenuDropDown from "./CategoryMenuDropDown";
import DialogCommonDefault from "../../../../../components/dialogs/DialogCommonDefault";
import { CustomTheme } from "../../../../../types/customTheme";
import ProductWrapper from "./ProductWrapper";

const useStyles = makeStyles<CustomTheme>((theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(1.5),
    },
    categoryTitle: {
      backgroundColor: theme.palette.background.entity_highlight_background,
      position: "sticky",
      zIndex: 1,
      fontSize: "20px",
      top: "-0.5px",
      [theme.breakpoints.up("sm")]: {
        fontSize: "32px",
      },
      [theme.breakpoints.up("1280")]: {
        fontSize: "32px",
      },
    },
    categoryTitles: {
      backgroundColor: theme.palette.background.paper,
      position: "sticky",
      zIndex: 50,
      fontSize: "20px",
      top: "-0.5px",
      [theme.breakpoints.up("sm")]: {
        fontSize: "32px",
      },
      [theme.breakpoints.up("1280")]: {
        fontSize: "32px",
      },
    },
  }),
);

interface ProductModalContentProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  selectedWrapperIdList: string[];
  handleSubmitRewardsTypePoints: (
    ids: string[],
    isEdit: boolean,
    rewardId: string | null,
  ) => void;
  isEdit: boolean;
  rewardId: string | null;
  isLoadingButton: boolean;
  handleSelectProduct?: any;
  setSelectedWrapperIdList: any;
  menuNodes: any[];
  departmentList: any[];
  menuProducts: any;
  selectedWrapperIdListInitial: any;
  offerItemMap: any;
  selectedWrapperIdListInitialNew: any;
  setOfferItemMap: any;
  offerItemMapInitial: any;
}

const ProductsModalContent: React.FC<ProductModalContentProps> = ({
  isOpen,
  setIsOpen,
  selectedWrapperIdList,
  handleSubmitRewardsTypePoints,
  isEdit,
  rewardId,
  isLoadingButton,
  handleSelectProduct,
  setSelectedWrapperIdList,
  menuNodes,
  departmentList,
  menuProducts,
  selectedWrapperIdListInitial,
  selectedWrapperIdListInitialNew,
  offerItemMap,
  setOfferItemMap,
  offerItemMapInitial,
}) => {
  const [selectedCatMenuTitle, setSelectedCatMenuTitle] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [removedLinkedIdLists, setRemovedLinkedIdLists] = useState<any>({});
  const [editableRewardDetails, setEditableRewardDetails] = useState<any>([]);
  const [revertExpand, setRevertExpand] = useState("");
  const [isColorChange, setIsColorChange] = useState("");
  const elementsByTitle: any = useRef({});

  const theme = useTheme<CustomTheme>();
  const classes = useStyles();
  const maxWidthCustom = useMediaQuery(theme.breakpoints.down("1280"));

  useEffect(() => {
    if (menuNodes.length > 0) {
      setSelectedCatMenuTitle(menuNodes[0].name);
    }
  }, [menuNodes]);

  const handleChangeCatMenu = (event: any) => {
    setSelectedCatMenuTitle(event.name);
  };

  const handleClose = () => setAnchorEl(null);
  const handleClick = (event: any) => setAnchorEl(event.currentTarget);
  const open = Boolean(anchorEl);

  const handleButtonClickMobile = (title: any) => {
    const targetElement = elementsByTitle.current[title];
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleUpdateIdList = (event: any, product: any) => {
    if (event) event.stopPropagation();
    setRemovedLinkedIdLists((prev: any) => {
      const { [product.directoryId]: removed, ...rest } = prev;
      return rest;
    });
    setIsColorChange(product.directoryId);
  };

  const handleNavigate = (product: any, level: any, data: any) => {
    setRemovedLinkedIdLists((prev: any) => ({
      ...prev,
      [data.directoryId]: {
        ...prev[data.directoryId],
        id: product.id,
        directoryLevel: level,
      },
    }));
  };

  const handleClearStrip = (product: any) => {
    const newRemovedLinkedIds = { ...removedLinkedIdLists };
    delete newRemovedLinkedIds[product.id];
    setRemovedLinkedIdLists(newRemovedLinkedIds);
  };

  const handleClickLinkedId = (item: any, category: any) => {
    setRevertExpand(item.id);
    const newRemovedLinkedIds = { ...removedLinkedIdLists };
    const key = item.directoryLevel === 1 ? item.id : category.directoryId;
    newRemovedLinkedIds[key] = {
      id: item.id,
      directoryLevel: item.directoryLevel,
    };
    setRemovedLinkedIdLists(newRemovedLinkedIds);
  };
  return (
    <DialogCommonDefault
      open={isOpen}
      setOpen={setIsOpen}
      isNeedFixedHeight
      maxWidth="xl"
    >
      <>
        <div
          style={{
            position: "fixed",
            top: 32,
            paddingTop: 20,
            zIndex: 1000,
            right: 50,
            left: 57,
            backgroundColor: "transparent",
          }}
        >
          <div style={{ marginRight: 28 }}>
            <Typography variant="h4">
              {isEdit ? "Edit Members" : "Add Members"}
            </Typography>
            <Grid container spacing={2} className={classes.root}>
              <Grid item xs={12}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {!_.isEmpty(menuNodes) && selectedCatMenuTitle && (
                      <CategoryMenuDropDown
                        categoryMenuList={menuNodes}
                        selectedCatMenuTitle={selectedCatMenuTitle}
                        handleChangeCatMenu={handleChangeCatMenu}
                      />
                    )}
                    {!_.isEmpty(menuNodes) && departmentList && (
                      <>
                        <IconButton
                          id="basic-button"
                          style={{
                            fontSize: 11,
                            marginLeft: 12,
                            backgroundColor:
                              theme.palette.background.entity_background,
                          }}
                          onClick={handleClick}
                        >
                          {open ? <CloseIcon /> : <MenuIcon />}
                        </IconButton>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          PaperProps={{
                            elevation: 0,
                            style: {
                              borderRadius: 10,
                              border: `1px solid ${theme.palette.background.entity_border}`,
                              marginTop: 60,
                              marginLeft: 40,
                            },
                          }}
                        >
                          {departmentList.map((department: any) => (
                            <MenuItem
                              key={department.id}
                              onClick={() => {
                                handleButtonClickMobile(
                                  `department ${department.id}`,
                                );
                                handleClose();
                              }}
                            >
                              <Typography>{department.name}</Typography>
                            </MenuItem>
                          ))}
                        </Menu>
                      </>
                    )}
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ButtonCommon
                      variant="contained"
                      style={{
                        fontSize: 11,
                        width: 100,
                        marginRight: 8,
                        height: 32,
                      }}
                      disabled={isLoadingButton}
                      color="yellow"
                      onClick={() => {
                        setSelectedWrapperIdList(
                          selectedWrapperIdListInitialNew,
                        );
                        setOfferItemMap(offerItemMapInitial);
                        setIsOpen(false);
                      }}
                    >
                      Cancel
                    </ButtonCommon>
                    <ButtonCommon
                      variant="contained"
                      style={{
                        fontSize: 11,
                        marginLeft: 4,
                        width: 100,
                        height: 32,
                      }}
                      isLoadingPage={isLoadingButton}
                      disabled={isLoadingButton}
                      color={isEdit ? "orange" : "green"}
                      onClick={() =>
                        handleSubmitRewardsTypePoints(
                          selectedWrapperIdList,
                          isEdit,
                          rewardId,
                        )
                      }
                    >
                      {"Done"}
                    </ButtonCommon>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <DialogContent style={{ padding: "0px 24px", marginTop: "160px" }}>
          {departmentList.length > 0 ? (
            departmentList.map((category: any, index) => (
              <div key={category.id}>
                <Typography
                  align="left"
                  className={
                    menuNodes.length
                      ? classes.categoryTitles
                      : classes.categoryTitle
                  }
                  ref={(ref) =>
                    (elementsByTitle.current[`department ${category.id}`] = ref)
                  }
                >
                  {category.name}
                </Typography>
                <Grid
                  container
                  style={{
                    marginTop: index === 0 && maxWidthCustom ? "12px" : "0px",
                  }}
                >
                  <ProductWrapper
                    wrapperProduct={category.product}
                    removedLinkedIdList={Object.keys(removedLinkedIdLists)}
                    removedLinkedIdLists={removedLinkedIdLists}
                    handleUpdateIdList={handleUpdateIdList}
                    index={index}
                    isColorChange={isColorChange}
                    revertExpand={revertExpand}
                    category={category}
                    handleClickLinkedId={handleClickLinkedId}
                    handleNavigate={handleNavigate}
                    handleClearStrip={handleClearStrip}
                    handleSelectProduct={handleSelectProduct}
                    selectedWrapperIdList={selectedWrapperIdList}
                    setSelectedWrapperIdList={setSelectedWrapperIdList}
                    editableRewardDetails={editableRewardDetails}
                    menuProducts={menuProducts}
                    offerItemMap={offerItemMap}
                  />
                </Grid>
              </div>
            ))
          ) : (
            <div
              style={{
                width: "100%",
                marginTop: "16%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography variant="h3">No Menus Available.</Typography>
            </div>
          )}
        </DialogContent>
      </>
    </DialogCommonDefault>
  );
};

export default ProductsModalContent;
